import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { Page } from '../model/Page';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SmsNotificationLotteryResultResponse } from '../model/SmsNotificationLotteryResultResponse';

@Injectable({
  providedIn: 'root'
})
export class SMSNotificationLotteryResultService {
  
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  fetchList(page: number, size: number, status: string, filterText: string) {
    return this.httpClient.post<{data: Page<SmsNotificationLotteryResultResponse>, status: string, errorMessage: string}>(
        ApiUrls.smsNotificationLotteryResultListFetchPageByFilterUrl + `?page=${page}&size=${size}`, {
          status, filterText
        });
  }

  sendSMS(key: number) {
    return this.httpClient.get<{status: string, errorMessage: string}>(
      ApiUrls.smsNotificationLotteryResultSendSmsUrl.replace('{key}', key.toString())
    );
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

}
